import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map, skip, startWith, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public currentLang$: Observable<string>;

  constructor(private translateService: TranslateService) {
    this.currentLang$ = this.translateService.onLangChange.pipe(
      skip(1),
      map((langChange: LangChangeEvent) => langChange.lang),
      tap((lang) => {
        moment.locale(lang);
        this.saveCurrentLang(lang);
      }),
      startWith(this.getCurrentLang()),
    );
    this.currentLang$.subscribe();
  }

  getCurrentLang(): string {
    const browserLang = this.translateService.getBrowserLang();
    if (localStorage && localStorage['locale']) {
      return localStorage['locale'];
    } else if (browserLang) {
      if (browserLang.startsWith('cs')) {
        return 'cs';
      } else if (browserLang.startsWith('fr')) {
        if (browserLang.toLowerCase().indexOf('ca') >= 0) {
          return 'fr-ca';
        }
        return 'fr-fr';
      } else if (browserLang.startsWith('nl')) {
        return 'nl';
      } else if (browserLang.startsWith('de')) {
        return 'de';
      } else if (browserLang.startsWith('es')) {
        return 'es-419';
      }
    }
    return 'en';
  }

  saveCurrentLang(locale: string): void {
    if (localStorage) {
      localStorage['locale'] = locale;
    }
  }
}
